// components/SimValidationSummary.tsx
import React from "react";
import { Alert, Badge, Card, ListGroup, Table } from "react-bootstrap";

const SimValidationSummary = ({ report, error }) => {
  if (error) {
    return (
      <Alert variant="danger" className="mt-2">
        {error}
      </Alert>
    );
  }
  if (!report) return null;

  const hasIssues = report.issues && report.issues.length > 0;
  const dupCount = report.duplicateCounts
    ? Object.keys(report.duplicateCounts).length
    : 0;

  return (
    <Card className="mt-3">
      <Card.Body>
        <Card.Title className="d-flex align-items-center gap-2">
          Validation
          {report.valid ? (
            <Badge bg="success">Valid</Badge>
          ) : (
            <Badge bg="danger">Invalid</Badge>
          )}
        </Card.Title>

        <ListGroup horizontal className="my-2">
          <ListGroup.Item>
            Rows: <strong>{report.totalRows ?? 0}</strong>
          </ListGroup.Item>
          <ListGroup.Item>
            Valid: <strong>{report.validRows ?? 0}</strong>
          </ListGroup.Item>
          <ListGroup.Item>
            Issues: <strong>{report.issues?.length ?? 0}</strong>
          </ListGroup.Item>
          <ListGroup.Item>
            Duplicates: <strong>{dupCount}</strong>
          </ListGroup.Item>
        </ListGroup>

        {hasIssues && (
          <>
            <div className="small text-muted mb-2">
              Showing up to first 100 issues
            </div>
            <Table bordered hover responsive size="sm">
              <thead>
                <tr>
                  <th># Row</th>
                  <th>Column</th>
                  <th>Message</th>
                  <th>Value</th>
                </tr>
              </thead>
              <tbody>
                {report.issues.slice(0, 100).map((it, idx) => (
                  <tr key={idx}>
                    <td>{it.row}</td>
                    <td>{it.column}</td>
                    <td>{it.message}</td>
                    <td>
                      <code>{it.value}</code>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </Card.Body>
    </Card>
  );
};

export default SimValidationSummary;
